import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";

const data = [
  {
    icon: <HiShieldCheck />,
    heading: "Best interest rates on the market",
    detail:
      "Enjoy highly competitive interest rates tailored to maximize your savings and investment returns.",
  },
  {
    icon: <MdCancel />,
    heading: "Prevent unstable prices",
    detail:
      "Price instability in the real estate market can lead to market uncertainty, affordability issues, and investment risks. To ensure stable pricing and sustainable growth, key measures must be implemented by developers, policymakers, investors, and financial institutions.",
    },
  {
    icon: <MdAnalytics />,
    heading: "Best price on the market",
    detail:
      "We offer unbeatable prices without compromising on quality. Compare, save, or investing, we ensure you get the most competitive deal available.",
  },
];
export default data;